// Case-sensitive alphanumeric minus visually-confusable glyphs.
// Removed: 0/O/o, 1/I/l, 2/Z/z, 5/S/s, 8/B
// export const PARTY_CODE_ALPHABET =
//   "34679ACDEFGHJKLMNPQRTUVWXYabcdefghijkmnpqrtuvwxy";
export const PARTY_CODE_ALPHABET = '0123456789';
  export const PARTY_CODE_LENGTH = 7;

const PARTY_CODE_PATTERN = new RegExp(
  `^[${PARTY_CODE_ALPHABET}]{${PARTY_CODE_LENGTH}}$`
);

export function generatePartyCode(): string {
  const n = PARTY_CODE_ALPHABET.length;
  // Rejection sampling to avoid modulo bias from a 48-char alphabet.
  const maxAcceptable = Math.floor(256 / n) * n;
  const out = new Array<string>(PARTY_CODE_LENGTH);
  const buf = new Uint8Array(1);
  for (let i = 0; i < PARTY_CODE_LENGTH; i++) {
    do {
      crypto.getRandomValues(buf);
    } while (buf[0] >= maxAcceptable);
    out[i] = PARTY_CODE_ALPHABET[buf[0] % n];
  }
  return out.join("");
}

export function isPartyCodeShape(s: string): boolean {
  return PARTY_CODE_PATTERN.test(s);
}
